import React, { Component } from 'react';
import { isLoggedIn, cssFormInputLabel, businessIdHeader, getSessionValue, fetchSignedMessage, getMethod, postMethod, httpOKsuccess } from './Library';
import ReactDOM from 'react-dom';
import { NavMenu } from '../components/NavMenu';
import { Link } from '../../node_modules/react-router-dom/dist/index';

export class DisableUsers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            usersData: []
        }
    }

    async componentDidMount() {
        await isLoggedIn();
        this.getUsersData();
    }

    async getUsersData() {
        try {
            const businessId = getSessionValue(businessIdHeader);
            const usersResponse = await fetchSignedMessage(null, 'business/' + businessId + '/users', getMethod);
            const usersData = await usersResponse.json();

            this.setState({ usersData: usersData });

        }
        catch (error) {
            console.log(error);
            const networkErrorEmail = "mailto:tech@receiptsandrewards.com?subject=Login%20-%20Network%20Error&body=A%20User%20is%20unable%20to%20logon%20to%20" + window.location.host;
            var messageLabel = document.getElementById("errorMessage");
            ReactDOM.render(<label className={cssFormInputLabel} >There appears to be a network error. Please <a href={networkErrorEmail}>contact Receipts and Rewards</a> and we will fix it.</label>, messageLabel);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async disableUser(userId) {
        //try {
            var successful;
            const businessId = getSessionValue(businessIdHeader);
            const deleteResponse = await fetchSignedMessage(null, 'business/' + businessId + '/disable/' + userId, postMethod);

            successful = (deleteResponse.status == httpOKsuccess);

            if (successful) {
                let users = this.state.usersData.filter((item, index) => item.identityId !== userId); 
                this.setState({ usersData: users });
            }
        //}
    }

    render() {
        return (
            <><NavMenu />
            <table>
                <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email Address</th>
                    <th></th>
                </tr>
                {this.state.usersData.map((user) => (
                    <tr key={user.identityId}>
                        <td>{user.firstName}</td>
                        <td>{user.lastName}</td>
                        <td>{user.emailAddress}</td>
                        <td><Link className="text-dark" onClick={() => { this.disableUser(user.identityId) }}>Disable</Link></td>
                    </tr>
                )) }
                </table>
            </>
        )
    }
}

